(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-buffering"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-buffering"] = factory(root["mggp-player"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/mggp-plugin-buffering.js":
/*!**************************************!*\
  !*** ./src/mggp-plugin-buffering.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



/**
 * Created by User on 18/10/2016.
 */
var MggpPlugin = (__webpack_require__(/*! mggp-player */ "mggp-player").Plugin);
function MggpPluginBuffering(player, config) {
	MggpPlugin.apply(this, arguments);

	var self = this;
	var video = null;
	var becamePaused = false;

	this.dispose = function () {
		self.player.off('property:state', onStateChange);
		self.player.off('player:timeUpdate', onTimeUpdate);

		video = null;
		becamePaused = false;
	};

	this.setVideo = function (pVideo) {
		video = pVideo;
		if (video) {
			self.player.on('property:state', onStateChange);
		}
	};

	function startObserving() {
		self.player.on('player:timeUpdate', onTimeUpdate);
	}

	function stopObserving() {
		self.player.off('player:timeUpdate', onTimeUpdate);
	}

	function onStateChange(event) {
		//don't use it when casting to airplay
		if (self.player.get('airplay:state') === 'connected') {
			return;
		}

		if (event.data === 3) {
			startObserving();
		}
	}

	function onTimeUpdate() {
		if (video.seeking) {
			if (becamePaused) {
				becamePaused = false;
				video.play();
			}
			stopObserving();
			return;
		}

		if (Number.isFinite(video.duration) && video.duration >= MggpPluginBuffering.MIN_ACCEPTED_DURATION && video.duration - video.currentTime > MggpPluginBuffering.MIN_BUFFER) {
			if (!video.paused) {
				becamePaused = true;
				video.pause();
			}
			var buffer = getCurrentBufferTime(video);
			if (buffer >= MggpPluginBuffering.MIN_BUFFER) {
				stopObserving();
				if (becamePaused) {
					becamePaused = false;
					video.play();
				}
			}
		} else {
			stopObserving();
		}
	}

	function getCurrentBufferTime(video) {
		var result = -1;
		if (video && video.buffered) {
			var times = video.buffered;
			var slices = [];
			var i;
			var j = 0;
			for (i = 0; i < times.length; ++i) {
				if (i !== 0) {
					if (times.start(i) - slices[j].end <= 1) {
						slices[j].end = times.end(i);
					} else {
						slices[++j] = { start: times.start(i), end: times.end(i) };
					}
				} else {
					slices.push({ start: times.start(i), end: times.end(i) });
				}
			}

			for (i = 0; i < slices.length; ++i) {
				if (slices[i].start - 3 <= video.currentTime && slices[i].end >= video.currentTime) {
					result = slices[i].end - video.currentTime;
					break;
				}
			}
		}
		return result;
	}
}
MggpPluginBuffering.prototype = Object.create(MggpPlugin.prototype);
MggpPluginBuffering.prototype.constructor = MggpPluginBuffering;
MggpPluginBuffering.MIN_BUFFER = 10;
MggpPluginBuffering.MIN_ACCEPTED_DURATION = 60;

module.exports = MggpPluginBuffering;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/mggp-plugin-buffering.js");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});